import { render, staticRenderFns } from "./ManufacturingGuide.vue?vue&type=template&id=4335ce38&scoped=true"
import script from "./ManufacturingGuide.vue?vue&type=script&lang=js"
export * from "./ManufacturingGuide.vue?vue&type=script&lang=js"
import style0 from "./ManufacturingGuide.vue?vue&type=style&index=0&id=4335ce38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4335ce38",
  null
  
)

export default component.exports